import ToggleSwitch from './toggleSwitch'
export default ToggleSwitch
